import { useState, useEffect } from 'react'
import FamCFO from './famcfo.jsx'
const T = { bg:'#F6F6F9',surf:'#FFFFFF',border:'#E6E6EE',text:'#1B1B2B',muted:'#71718C',accent:'#635BFF',red:'#E5484D' }
export default function App() {
  const [status,setStatus]=useState('checking')
  const [password,setPassword]=useState('')
  const [errorMsg,setErrorMsg]=useState('')
  const [loading,setLoading]=useState(false)
  useEffect(()=>{ localStorage.getItem('famcfo_token')?setStatus('authed'):setStatus('login') },[])
  const login=async(e)=>{
    e.preventDefault(); setLoading(true); setErrorMsg('')
    try {
      const res=await fetch('/.netlify/functions/auth',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({password})})
      if(res.ok){const{token}=await res.json();localStorage.setItem('famcfo_token',token);setStatus('authed')}
      else{
        let msg='Wrong password.'
        try{const d=await res.json();if(d?.error)msg=d.error}catch{}
        setErrorMsg(msg);setPassword('')
      }
    } catch{setErrorMsg('Connection error.')}
    setLoading(false)
  }
  const logout=()=>{localStorage.removeItem('famcfo_token');setPassword('');setStatus('login')}
  if(status==='checking') return <div style={{height:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:T.bg,color:T.muted,fontFamily:"'Geist',sans-serif"}}>Loading…</div>
  if(status==='login') return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@500;600;700;800&family=Geist:wght@400;500;600;700&display=swap');*{box-sizing:border-box;margin:0;padding:0;}html{-webkit-font-smoothing:antialiased;}body{background:${T.bg};}`}</style>
      <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:T.bg,fontFamily:"'Geist',sans-serif"}}>
        <div style={{width:360,background:T.surf,border:`1px solid ${T.border}`,borderRadius:20,padding:32,display:'flex',flexDirection:'column',gap:20,boxShadow:'0 1px 2px rgba(27,27,43,0.04), 0 24px 48px -20px rgba(27,27,43,0.14)'}}>
          <div style={{textAlign:'center',display:'flex',flexDirection:'column',alignItems:'center',gap:12}}>
            <div style={{width:52,height:52,borderRadius:16,background:'linear-gradient(135deg,#635BFF,#9A6BFF)',boxShadow:'0 10px 24px -8px rgba(99,91,255,0.6)',display:'flex',alignItems:'center',justifyContent:'center'}}>
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="4 17 9 11 13 14 20 6"/><polyline points="14 6 20 6 20 12"/></svg>
            </div>
            <div>
              <div style={{fontFamily:"'Outfit',sans-serif",fontSize:28,fontWeight:800,letterSpacing:'-0.02em',lineHeight:1,marginBottom:6}}>
                <span style={{color:T.text}}>Fam</span><span style={{background:'linear-gradient(90deg,#635BFF,#9A6BFF)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent'}}>CFO</span>
              </div>
              <div style={{fontSize:13,color:T.muted}}>Family financial command centre</div>
            </div>
          </div>
          <form onSubmit={login} style={{display:'flex',flexDirection:'column',gap:12}}>
            {/* 16px font is load-bearing: anything smaller triggers iOS Safari's zoom-on-focus */}
            <input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="Password" autoFocus
              style={{background:T.bg,border:`1.5px solid ${T.border}`,borderRadius:12,padding:'11px 14px',fontSize:16,color:T.text,outline:'none',fontFamily:"'Geist',sans-serif"}}/>
            {errorMsg&&<div style={{fontSize:12,color:T.red,fontFamily:"'Geist',sans-serif"}}>{errorMsg}</div>}
            <button type="submit" disabled={!password||loading}
              style={{background:T.accent,color:'#fff',border:'none',borderRadius:999,padding:'11px 0',fontSize:14,fontWeight:600,cursor:loading||!password?'not-allowed':'pointer',opacity:loading||!password?0.5:1,fontFamily:"'Geist',sans-serif",boxShadow:'0 2px 10px -2px rgba(99,91,255,0.5)'}}>
              {loading?'Signing in…':'Sign in'}
            </button>
          </form>
        </div>
      </div>
    </>
  )
  return <FamCFO token={localStorage.getItem('famcfo_token')} onLogout={logout}/>
}
